import { render, staticRenderFns } from "./reglementsPdf.vue?vue&type=template&id=ea80a60a&"
import script from "./reglementsPdf.vue?vue&type=script&lang=js&"
export * from "./reglementsPdf.vue?vue&type=script&lang=js&"
import style0 from "./reglementsPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports